import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    red: string;
    orange: string;
    yellow: string;
    green: string;
    blue: string;
    purple: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the red folder color option */
            red: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "folderColors.red?c=2uw1xyh23tvuq", defaultMessage: "Red" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the orange folder color option */
            orange: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "folderColors.orange?c=3vhjuuazt5uly", defaultMessage: "Orange" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the yellow folder color option */
            yellow: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "folderColors.yellow?c=2x5lkib4h0ozz", defaultMessage: "Yellow" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the green folder color option */
            green: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "folderColors.green?c=1fykzswqjsf4s", defaultMessage: "Green" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the blue folder color option */
            blue: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "folderColors.blue?c=2vz7mp8hnnpkm", defaultMessage: "Blue" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the purple folder color option */
            purple: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "folderColors.purple?c=3efojb8xcmoak", defaultMessage: "Purple" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
